import { IDoiMatKhauBody, ITaiKhoan } from 'src/types/TaiKhoan.type';
import http from 'src/utils/http';
import BaseService from './base.service';

export default class TaiKhoanService extends BaseService<ITaiKhoan> {
  constructor() {
    super('/tai-khoan');
  }

  public async doiMatKhau(body: IDoiMatKhauBody) {
    const { data } = await http.put<boolean>(`${this.url}/doi-mat-khau`, body);
    return data;
  }

  public async thongTinCaNhan() {
    const { data } = await http.get<ITaiKhoan>(`${this.url}/thong-tin-ca-nhan`);
    return data;
  }

  public async khoaTaiKhoan(id: number) {
    const { data } = await http.put<boolean>(`${this.url}/${id}/khoa`);
    return data;
  }

  public async moKhoaTaiKhoan(id: number) {
    const { data } = await http.put<boolean>(`${this.url}/${id}/mo-khoa`);
    return data;
  }

  public async DatLaiMatKhau(id: number) {
    const { data } = await http.put<boolean>(`${this.url}/${id}/dat-lai-mat-khau`);
    return data;
  }
}
